window._ = require('lodash');
import "@babel/polyfill";

import Vue from 'vue'
import store from './store'

Vue.component('iekatsu', require('./components/Iekatsu.vue'))

window.app = new Vue({
  el: '#wrap',
  store,
})



// WEBPACK FOOTER //
// ./assets/js/app.js